module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "uEElyRBSRY2EnZHJFvdT238"
    }
  }, [_c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("NO ANGELS")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("The Short Life and Brutal Death of Brandaline Rose DuVall")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("STEVE JACKSON")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('img', {
    staticClass: "calibre2",
    attrs: {
      "alt": "",
      "src": "Images/NA_080.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center1",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://WildBluePress.com",
      "target": "_blank"
    }
  }, [_vm._v("WildBluePress.com")]), _c('br', {
    staticClass: "calibre3"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63762b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/NA_002.vue
// module id = 72
// module chunks = 0